import { reactive } from 'vue'
import type { Task, TaskLabel, TaskStatus, TaskType, Priority } from '@/types'

export interface TaskFilters {
  search: string
  status: TaskStatus | 'all'
  priority: Priority | 'all'
  type: TaskType | 'all'
  assignedTo: string | 'all'
  projectId: string | 'all'
  showArchived: boolean
}

export interface TasksState {
  tasks: Task[]
  selectedTask: Task | null
  taskLabels: TaskLabel[]
  filters: TaskFilters
  isLoading: boolean
  error: string | null
}

export const getInitialState = (): TasksState => ({
  tasks: [],
  selectedTask: null,
  taskLabels: [],
  filters: {
    search: '',
    status: 'all',
    priority: 'all',
    type: 'all',
    assignedTo: 'all',
    projectId: 'all',
    showArchived: false,
  },
  isLoading: false,
  error: null,
})

export const createState = (): TasksState => {
  return reactive(getInitialState())
}

export const resetState = (state: TasksState): void => {
  const initial = getInitialState()
  state.tasks = initial.tasks
  state.selectedTask = initial.selectedTask
  state.taskLabels = initial.taskLabels
  state.filters = initial.filters
  state.isLoading = initial.isLoading
  state.error = initial.error
}
